import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const EditNew24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.6559 5.30826C17.9172 4.5909 16.6017 4.59682 15.8725 5.32602L5.78298 15.4156L5.03592 18.9641L8.58445 18.217L18.674 8.12749C19.3849 7.41658 19.4392 6.20823 18.6559 5.30826ZM14.6176 4.07116C16.0459 2.64295 18.5006 2.64295 19.9288 4.07116C19.9411 4.08345 19.9531 4.09609 19.9646 4.10908C21.3262 5.64087 21.376 7.93521 19.9288 9.38236L9.65279 19.6584C9.53108 19.7801 9.3766 19.8638 9.20816 19.8993L4.07014 20.981C3.77671 21.0427 3.47194 20.9521 3.25991 20.7401C3.04788 20.5281 2.95728 20.2233 3.01905 19.9299L4.10074 14.7918C4.1362 14.6234 4.21988 14.4689 4.34159 14.3472L14.6176 4.07116Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
